import { render, staticRenderFns } from "./ConfigAlertHttpPost.vue?vue&type=template&id=6a2e3d48&scoped=true"
import script from "./ConfigAlertHttpPost.vue?vue&type=script&lang=js"
export * from "./ConfigAlertHttpPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e3d48",
  null
  
)

export default component.exports